const iconLoaderPlugin = (element, plugins, app) => {
    var _a;
    const plugin = plugins === null || plugins === void 0 ? void 0 : plugins.find((p) => p.name === 'icon-loader');
    if (!app) {
        return;
    }
    if ((_a = plugin === null || plugin === void 0 ? void 0 : plugin.options) === null || _a === void 0 ? void 0 : _a.packs.includes('material-icons')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
        const insertionPoint = document.createElement('span');
        insertionPoint.id = 'direflow_material-icons';
        insertionPoint.appendChild(link);
        return [app, insertionPoint];
    }
};
export default iconLoaderPlugin;
